// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33AW9","col":"styles_col__34CJh"};